"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useControlledQuantityPicker = void 0;
var _analyticsData = require("@ori/analytics-data");
var _logger = require("@ori/logger");
var _react = require("react");
var _logger2 = require("../../logger");
var _utils = require("../../utils");
const useControlledQuantityPicker = ({
  canBeDeleted,
  canBeReduced,
  initialQuantity,
  itemCode,
  lineNumber,
  maxQuantity,
  quantity,
  removeItemHandler
}) => {
  const logger = (0, _logger.useLogger)('useControlledQuantityPicker');
  const minQuantity = canBeDeleted ? canBeReduced ? 0 : initialQuantity : 1;

  /**
   * This handler is called when the quantity is changed
   */
  const updateQuantityHandler = (0, _react.useCallback)(async ({
    itemCode: code,
    lineNumber: line,
    quantity: currentQuantity,
    previousQuantity
  }) => {
    (0, _logger2.logDebug)(`updateQuantityHandler triggered for ${code} in line ${line} with quantity ${currentQuantity} and previous quantity was ${previousQuantity}.`);
    try {
      await (0, _utils.updateBasketItem)({
        itemCode: code,
        lineNumber: line,
        placement: _analyticsData.Placement.Minibag,
        previousQuantity,
        quantity: currentQuantity
      });
    } catch (error) {
      (0, _utils.showErrorNotification)('genericError');
      if (error instanceof Error) {
        logger.error(error);
      } else {
        const newError = new Error('updateQuantityHandler Error', {
          cause: error
        });
        logger.error(newError);
      }
    }
  }, [logger]);

  /**
   * This handler is called when the quantity is changed.
   */
  const quantityChangeHandler = (0, _react.useCallback)(async inputValue => {
    (0, _logger2.logDebug)(`quantityChangeHandler triggered for ${itemCode} in line ${lineNumber} with input value ${inputValue} and quantity is ${quantity}.`);
    // we do all checks one more time even this is done in the component
    // do not trigger anything if the input value is not a number and equal or greater than 0
    if (typeof inputValue !== 'number' || typeof inputValue === 'number' && inputValue < 0) {
      return;
    }
    let currentValue = inputValue;
    // remove item if the quantity is 0
    if (currentValue === 0) {
      void removeItemHandler();
      return;
    }
    // check min value
    if (currentValue < minQuantity) {
      currentValue = minQuantity;
      (0, _logger2.logDebug)(`Current value was limited to min quantity ${minQuantity}.`);
    }
    // check max value
    if (currentValue > maxQuantity) {
      currentValue = maxQuantity;
      (0, _logger2.logDebug)(`Current value was limited to min quantity ${minQuantity}.`);
    }
    // there was no change in quantity
    if (currentValue === quantity) {
      return;
    }
    await updateQuantityHandler({
      itemCode,
      lineNumber,
      quantity: currentValue,
      previousQuantity: initialQuantity
    });
  }, [initialQuantity, itemCode, lineNumber, maxQuantity, minQuantity, quantity, removeItemHandler, updateQuantityHandler]);

  /**
   * This is the callback that is passed to the QuantityPicker component.
   */
  const onQuantityChange = (0, _react.useCallback)((inputValue, id, source) => {
    (0, _logger2.logDebug)(`QuantityPicker.changeQuantity() -> inputValue: ${inputValue}, id: ${id}, source: ${source}`);
    quantityChangeHandler(inputValue).catch(error => {
      if (error instanceof Error) {
        logger.error(error);
      } else {
        const newError = new Error('onQuantityChange Error', {
          cause: error
        });
        logger.error(newError);
      }
      (0, _utils.showErrorNotification)();
    });
  }, [quantityChangeHandler, logger]);
  return {
    onQuantityChange,
    quantityChangeHandler,
    updateQuantityHandler
  };
};
exports.useControlledQuantityPicker = useControlledQuantityPicker;
